module.exports = __webpack_public_path__ + "img/3-2.5753970a.jpg";